import { render, staticRenderFns } from "./AppFormControlTelefoonnummer.vue?vue&type=template&id=104eaf8e&"
import script from "./AppFormControlTelefoonnummer.vue?vue&type=script&lang=ts&"
export * from "./AppFormControlTelefoonnummer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports